import React from 'react'
import { useTheme } from '@material-ui/core/styles'

import {
    benchHeight,
    benchWidth,
    buildStepToTransitionPath,
    buildTransitionToStepPath,
} from './flowLayout'

const ARROW_MARKER_ID = 'pipeline-flow-arrow'

interface FlowConnectorsProps {
    transitionCount: number
}

export const FlowConnectors: React.FC<FlowConnectorsProps> = ({
    transitionCount,
}) => {
    const theme = useTheme()
    const width = benchWidth(transitionCount + 1)
    const height = benchHeight()
    const stroke = theme.palette.primary.main

    if (transitionCount <= 0) {
        return null
    }

    return (
        <svg
            width={width}
            height={height}
            style={{
                position: 'absolute',
                top: 0,
                left: 0,
                pointerEvents: 'none',
                zIndex: 1,
            }}
        >
            <defs>
                <marker
                    id={ARROW_MARKER_ID}
                    markerWidth="8"
                    markerHeight="8"
                    refX="7"
                    refY="4"
                    orient="auto"
                    markerUnits="strokeWidth"
                >
                    <path d="M0,0 L8,4 L0,8 Z" fill={stroke} />
                </marker>
            </defs>
            {Array.from({ length: transitionCount }, (_, index) => (
                <g key={index}>
                    <path
                        d={buildStepToTransitionPath(index)}
                        fill="none"
                        stroke={stroke}
                        strokeWidth={2}
                        strokeLinejoin="round"
                        markerEnd={`url(#${ARROW_MARKER_ID})`}
                    />
                    <path
                        d={buildTransitionToStepPath(index)}
                        fill="none"
                        stroke={stroke}
                        strokeWidth={2}
                        strokeLinejoin="round"
                        markerEnd={`url(#${ARROW_MARKER_ID})`}
                    />
                </g>
            ))}
        </svg>
    )
}
